import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTags } from "@fortawesome/free-solid-svg-icons";
import { faLongArrowAltRight, faChevronRight } from "@fortawesome/free-solid-svg-icons";

const ModuleCard = ({ content, istag }) => {
  const { grade, module, title, tags, url, color, year } = content;
  return (
    <div className={`card card-module border-${color} h-100`}>
      <div className="card-body">
        <div>
          <p>
          <small className={`c-${color}`}> {grade.name}* <FontAwesomeIcon icon={faChevronRight} /> </small> <small className={`c-${color}`}> {module}</small>
          </p>
          <h5  className={`card-title text-dark`}>{title}</h5>
          <p className="tags">
            {" "}
            <FontAwesomeIcon icon={faTags} />{" "}
            {tags.map((t, idx) => (
              <span key={idx}>
                <a href={t.url}>{t.name}</a>
                {idx === tags.length - 1 ? "" : ", "}
              </span>
            ))}
          </p>
          <p className="c-grey m-0"><small>*Contenido sugerido para {year}</small></p>
        </div>

        <div className="w-100 text-end">
          <a href={istag ? 'https://ciudadania.pe/actividades-interactivas/'+url : url} className={`c-${color} btn-module`}>
            Explorar contenido <FontAwesomeIcon icon={faLongArrowAltRight} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ModuleCard;
